import styled from 'styled-components';
import colors from '../../../../../helpers/colors';
import fonts from '../../../../../helpers/fonts';
import mediaQuery from '../../../../../helpers/mediaQuery';
import spacing from '../../../../../helpers/spacing';
import Icon from '../../../../Icon';
import { buttonStyling } from '../styles';

export const IconWithMargin = styled(Icon)`
  margin-left: ${spacing(1.5)};
`;

export const TertiaryButtonWithIcon = styled.a`
  ${buttonStyling};
  ${fonts.paragraph}
  cursor: pointer;
  transition: all 0.3s ease-out;

  height: ${spacing(6)};
  align-self: center;
  display: flex;
  align-items: center;
  padding: 0;

  background: ${colors.neutral08};
  & {
    color: ${colors.core01};
  }

  /* Disable browser default focus behaviour */
  outline: none;
  border: 2px solid transparent;
  border-radius: 8px;

  &:hover {
    text-decoration: underline;
    /* Using text shadow instead of font-weight: bold to avoid button width jumping */
    text-shadow: 0 0 0.5px ${colors.core01}, 0 0 0.5px ${colors.core01};
  }

  :focus-visible {
    border-color: ${colors.core01};
  }

  ${mediaQuery.tabletPortrait`
    height: ${spacing(5)};
    min-width: 0;
  `}
`;
